<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">Currency From <span class="text-danger">*</span> </label>
        <div>
          <select
            ref="currency_id_from"
            v-model.number="model.currency_id_from"
            class="form-control"
            :class="{ 'is-invalid': errors.has('currency_id_from') }"
          >
            <option value="">--select--</option>
            <option v-for="(currency, id) in currencies" :key="id" :value="id">
              {{ currency }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('currency_id_from')">
            {{ errors.first('currency_id_from') }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">Currency To <span class="text-danger">*</span> </label>
        <select
          v-model.number="model.currency_id_to"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_id_to') }"
        >
          <option value="">--select--</option>
          <option v-for="(currency, id) in currencies" :key="id" :value="id">
            {{ currency }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('currency_id_to')">
          {{ errors.first('currency_id_to') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"> Rate <span class="text-danger">*</span> </label>
        <input
          v-model.number="model.fx_rate"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('fx_rate') }"
          placeholder="Enter rate"
        />
        <div class="invalid-feedback" v-if="errors.has('fx_rate')">
          {{ errors.first('fx_rate') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          Cancel
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          Update
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="save" v-else>
          Save
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'exchange-rate-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        currency_id_from: '',
        currency_id_to: '',
        fx_rate: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  computed: {
    ...mapState('administration/exchangeRate', ['currencies'])
  },
  mounted() {
    this.$refs.currency_id_from.focus()
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('success_update')
      this.$router.push({ name: 'exchange-rate' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('administration/exchangeRate/create', this.model)
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.currency_id_from.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('administration/exchangeRate/update', this.model)

        this.$toasted.success(response.message)
        this.$router.push({ name: 'exchange-rate' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.currency_id_from.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return

      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.currency_id_from = ''
      this.model.currency_id_to = ''
      this.model.fx_rate = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
